import { render, staticRenderFns } from "./carDisinfectManagement.vue?vue&type=template&id=4084ea02&scoped=true"
import script from "./carDisinfectManagement.vue?vue&type=script&lang=js"
export * from "./carDisinfectManagement.vue?vue&type=script&lang=js"
import style0 from "./carDisinfectManagement.vue?vue&type=style&index=0&id=4084ea02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084ea02",
  null
  
)

export default component.exports